import {throwErrorWithMessage} from "@web-libs/core/errors/utilities/error-throwing";

async function tryJson(response: Response): Promise<any> {
    return response.clone().json();
}

async function tryText(response: Response): Promise<string> {
    return response.clone().text();
}

async function tryBlob(response: Response): Promise<Blob> {
    return response.clone().blob();
}

const parseErrorMessage = 'Error while parsing fetch-response. Response Type is probably not JSON or Text.';
async function parseResponse(response: Response): Promise<any|string> {
    if(
        response.headers.get('Content-Type')?.includes('application/octet-stream') ||
        response.headers.get('Content-Type')?.includes('audio/') ||
        response.headers.get('Content-Type')?.includes('video/') ||
        response.headers.get('Content-Type')?.includes('image/')
    ) {
        return tryBlob(response).catch(() => tryJson(response)).catch(() => tryText(response));
    }
    return tryJson(response)
        .catch(() => {
          // Error logging removed
          tryText(response);
        })
        .catch(e => {
          // Error logging removed
            throwErrorWithMessage(parseErrorMessage, e)
        });
}

export { parseResponse}
